module.exports = __webpack_public_path__ + "static/img/SOS_red.121e8ca0.png";